module.exports = __webpack_public_path__ + "fonts/dFanZfeM_74wlPZtksIFaj8CRHGZV3B3X6_0f1Nk.woff2";